import { BasicLayout } from '../../modules/Layouts/basicLayout'
import { State } from '../../reducers';
import { useDispatch, useSelector } from 'react-redux';

import ModalsControl from './Components/ModalsControl';
import { ViewFactura } from './Components/VisualizacionFactura/ViewFactura';
import { FooterView } from './Components/VisualizacionFactura/FooterView';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import BasicHeaderDocumentos from '../OtrosDocumentos/Components/BasicHeader';

const VisualizacionFactura = () => {
  const {activeFactura} = useSelector((state: State) => state.historial);
  const {tipoDocumentosEmision} = useSelector((state: State) => state.catalogos);
  const history = useHistory();

  // Capturar una sola vez al montar para que re-renders no alteren el valor
  const [returnPath] = useState<string>(
    () => sessionStorage.getItem('detailReturnPath') || '/history-invoice?reload=0'
  );

  useEffect(() => {
    if (!activeFactura) {
      sessionStorage.removeItem('detailReturnPath');
      history.push(returnPath);
    }
  }, []);

  const handleBack = () => {
    sessionStorage.removeItem('detailReturnPath');
  };

  return (
    <BasicLayout>
      {
        (activeFactura) &&
        (
          <>
            <ModalsControl />
            <BasicHeaderDocumentos
              title={'Detalle de ' + tipoDocumentosEmision.find((dte) => dte.codigodocumento === activeFactura?.DetallesDTE?.identificacion?.tipoDte)?.nombre}
              url={returnPath}
              onClick={handleBack}
            />
            <ViewFactura />
            <FooterView />
          </>
        )
      }
    </BasicLayout>
  )
}

export default VisualizacionFactura;
